export enum CpsMessageBarType {
  INFO = 0,
  ERROR = 1,
  BLOCKED = 2,
  SEVERE_WARNING = 3,
  SUCCESS = 4,
  WARNING = 5
}
